import Http from '@thales/http/src/index'
import { message } from 'ant-design-vue'
import { getToken, getSign, getAppToken } from '../auth'
import { isNil } from '../type'
import sessionExpiredHandler from './sessionExpiredHandler'
import { setLoggerRequestInfo, setErrLogger } from './setLoggerRequestInfo'
import {handleCarrierData} from '../util'

export default (prefix, options = {}) => {
	return Http.create({
		withCredentials: options.withCredentials || false,
		prefix,
		$message: (error) => {
			const { message: msg } = error
			message.error(msg)
		},
		dataValidator: data => {
			const { code } = data
			const SUCCESS_CODE = [0, 2000000000, 200, 10000]
			return (
				SUCCESS_CODE.includes(Number(code))
			)
		},
		sessionExpiredHandler,
		loggerHandler(response) {
			setLoggerRequestInfo(response);
		},
		errLoggerHandler(error) {
			setErrLogger(error)
		},
		tokenHandler(config) {
			let { headers, token, sign } = config
			if (isNil(token)) {
				const appToken = getAppToken()
				if(appToken) {
					headers.Token = appToken
				} else if (getToken()) {
					token = getToken()
					headers.Authorization = token
					sign = getSign()
					headers.sign = sign
					headers.appId = 'oms'
          if(!config.noEnterprise&&handleCarrierData()){
            const {isConvertEnterprise,enterpriseCustomer}=handleCarrierData()
            headers.is_convert_enterprise = isConvertEnterprise
            headers.enterprise_customer = JSON.stringify(enterpriseCustomer)
          }
				} else {
					sign = getSign()
					headers.sign = sign
					headers.appId = 'oms'
				}
			}
			if (config.type === 'needDataEncrypt') {
				headers.needDataEncrypt = true;
				if (config.dataEncrypt) {
					headers.show=JSON.stringify(config.dataEncrypt)
				}
			}
			headers = headers || {}
			return { ...config, headers }
		},
		...options,
	})
}
